export default { sha: '0be9cab2ddac83ab3ca2506d30bcff17c79c19c2', buildNumber: 'undefined' }
